import React from "react";
const DashboardFiltersContext = React.createContext();
export default DashboardFiltersContext;